import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAssignCarrierPlanPrompt extends Layout {
    sourceDrsPayee: DataSource;
    textboxContact: Textbox;
    textboxDrsPayeemarkPlanId: Textbox;
    textboxDrsPayeesalespersonId: Textbox;
    textboxDrsPayeestartDate: Textbox;
}
